import {useEffect, useMemo} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import socketService from "../../../middleware/websocketMiddleware";
import {emojiListReplaced, fetchEmojiList} from "./slice";
import {ICustomEmoji} from "./types";
import {toEmojiMap} from "./customEmoji";

/** Список командных эмодзи с сервера и живое обновление `emoji:custom`. Подключён на уровне приложения (AppRealtime). */
export function useEmojiSocket() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(fetchEmojiList());
        const socket = socketService.connect();
        let wasConnected = socket.connected;
        const onList = (list: ICustomEmoji[]) => dispatch(emojiListReplaced(list));
        // После переподключения пропущенное догоняется перечитыванием; первый connect — не повод.
        const onConnect = () => {
            if (wasConnected) dispatch(fetchEmojiList());
            wasConnected = true;
        };
        socket.on("emoji:custom", onList);
        socket.on("connect", onConnect);
        return () => {
            socket.off("emoji:custom", onList);
            socket.off("connect", onConnect);
        };
    }, [dispatch]);
}

export const useCustomEmojiList = () => useAppSelector((s) => s.emoji.list);

/** Имя → эмодзи для показа в сообщениях и реакциях: действующие и удалённые (S4.1). */
export const useCustomEmojiMap = () => {
    const list = useCustomEmojiList();
    const deleted = useAppSelector((s) => s.emoji.deleted);
    return useMemo(() => toEmojiMap([...deleted, ...list]), [list, deleted]);
};
